import { render, staticRenderFns } from "./DivisoriaDescricaoContrato.vue?vue&type=template&id=897bf49a"
import script from "./DivisoriaDescricaoContrato.vue?vue&type=script&lang=js"
export * from "./DivisoriaDescricaoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports